
import get from 'lodash/get';
import { connect } from 'react-redux';
import { container } from 'op/container';
import { compose, withHandlers } from 'recompose';
import { withAxios } from 'op/components/auth';


export const withLocale = (section) =>
	connect(({ locale }) => {
		const current = container.resolve('locals')[locale.language.short];
		return {
			locale: {
				...(!!section ? get(current, section) : {}),
				_system: current._system || {},
				_meta: current._meta || {},
			},
		};
	});

export const withLanguageID =
	connect(({ locale }) => ({
		language: locale.language.id,
	}));

export const withLocaleModification = compose(
	connect(({ locale }) => ({
		locale: container.resolve('locals')[locale.language.short],
		available: locale.available,
	}), (dispatch) => ({
		setCurrentLocale: (locale) =>
			dispatch(container.resolve('actions').set_locale(locale)),
	})),
);
